"use strict";
exports.__esModule = true;
exports.isEmptyExample = function (example) {
    return !example.marker && !example.activationPhrase && !example.request;
};
exports.markers = [
    { text: 'запусти навык', hasRequest: false },
    { text: 'запусти чат с', hasRequest: false },
    { text: 'давай поиграем в', hasRequest: false },
    { text: 'сыграем в', hasRequest: false },
    { text: 'давай сыграем в', hasRequest: false },
    { text: 'поиграем в', hasRequest: false },
    { text: 'скажи', hasRequest: true },
    { text: 'попроси', hasRequest: true },
    { text: 'узнай у', hasRequest: true },
    { text: 'спроси у', hasRequest: true },
];
exports.reservedWords = {
    words: [
        'алиса',
        'яндекс',
        'станция'
    ],
    inflected: [
        'алиса',
        'алису',
        'алисе',
        'алисы',
        'алисой',
        'яндекс',
        'яндекса',
        'яндексу',
        'яндексом',
        'яндексе',
        'станция',
        'станции',
        'станцию',
        'станций',
    ]
};
exports.triggers = exports.markers.map(function (x) { return x.text; });
exports.quotedTriggers = exports.triggers.map(function (t) { return "\"" + t + "\""; }).join(', ');
exports.quotedReserved = exports.reservedWords.words.map(function (t) { return "\"" + t + "\""; }).join(', ');
exports.tokenize = function (text) {
    var regex = /([a-zа-я]+)/gu;
    var tokens = text.match(regex);
    return tokens || [];
};
exports.containsOneOf = function (text, items) {
    items = items.map(function (i) { return i.toLowerCase(); }).filter(Boolean);
    return items.some(function (i) { return text.indexOf(i) !== -1; });
};
exports.isQuoted = function (text) { return /^['"❝«].*['"„»]$/.test(text); };
